import { render, staticRenderFns } from "./pay-code-img.vue?vue&type=template&id=100523d4&scoped=true&"
import script from "./pay-code-img.vue?vue&type=script&lang=js&"
export * from "./pay-code-img.vue?vue&type=script&lang=js&"
import style0 from "./pay-code-img.vue?vue&type=style&index=0&id=100523d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100523d4",
  null
  
)

export default component.exports